import React, { useState } from "react";

const Header = () => {
  // State to manage form inputs
  const [formData, setFormData] = useState({
    location: "",
    timePeriod: "",
    tourType: "",
    email: "",
  });

  // State to manage form submission status
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState(null);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Send data to Formspree
      const response = await fetch("https://formspree.io/f/mwpldarw", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmissionStatus("success");
        setFormData({ location: "", timePeriod: "", tourType: "", email: "" }); // Reset form
      } else {
        setSubmissionStatus("error");
      }
    } catch (error) {
      setSubmissionStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <section
        data-w-id="e28930e1-2a20-16fe-df9c-7408f718e2c2"
        className="hero-section"
      >
        <div className="container">
          <div className="hero-column">
            {/* Hero Content */}
            <div className="hero-contents">
              <div className="mask">
                <h1
                  style={{
                    transform:
                      "translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                    transformStyle: "preserve-3d",
                  }}
                  className="heading"
                >
                  Where dreams <span className="text-primary">become</span>{" "}
                  destinations await extraordinary
                </h1>
              </div>
              <div className="margin-top-30px">
                <div className="mask">
                  <p
                    style={{
                      transform:
                        "translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                      transformStyle: "preserve-3d",
                    }}
                    className="text"
                  >
                    A travel agency is a private retailer or public service that
                    provides travel and tourism-related services
                  </p>
                </div>
              </div>
            </div>
            {/* Hero Images */}
            <div className="hero-image-wrapper">
              <div className="image-banner negative">
                <img
                  src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232620/loop_cgkiqi_t19xqu.png"
                  loading="lazy"
                  style={{
                    transform:
                      "translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                    opacity: 1,
                    transformStyle: "preserve-3d",
                  }}
                  alt=""
                  className="hero-image"
                />
                <div
                  style={{
                    height: "100%",
                    width: "300px",
                  }}
                  className="hero-bg-image"
                ></div>
                <img
                  src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5f91eb409840162546968_Group%201321314713.avif"
                  loading="lazy"
                  style={{
                    transform:
                      "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                    transformStyle: "preserve-3d",
                  }}
                  alt=""
                  className="_42px-svg-absolute"
                />
              </div>
              <div className="hero-vertical">
                <div className="image-banner">
                  <img
                    src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5f080823b6a2417095419_Rectangle%206171.avif"
                    loading="lazy"
                    style={{
                      transform:
                        "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                      transformStyle: "preserve-3d",
                    }}
                    alt=""
                    className="hero-image-landscape"
                  />
                  <div
                    style={{
                      opacity: 1,
                      transform:
                        "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                      transformStyle: "preserve-3d",
                    }}
                    className="hero-landscape-border"
                  ></div>
                </div>
                <div className="image-banner">
                  <img
                    src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232645/CAP_swdnft_farv9c.png"
                    loading="lazy"
                    style={{
                      transform:
                        "translate3d(0%, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                      opacity: 1,
                      transformStyle: "preserve-3d",
                    }}
                    alt=""
                    className="hero-image-2"
                  />
                  <div
                    style={{ width: " 100%" }}
                    className="hero-bg-image-secondary"
                  ></div>
                </div>
              </div>
            </div>
          </div>

          {/* Dynamic Search Form */}
          <div
            style={{
              opacity: 1,
              transform:
                "translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
              transformStyle: "preserve-3d",
            }}
            className="hero-search-form-wrapper w-form"
          >
            <form
              onSubmit={handleSubmit}
              className="hero-search-form"
              aria-label="city"
            >
              {/* Location */}
              <div className="horizontal-left-center-10px-gap">
                <div className="form-svg-wrapper">
                  <img
                    loading="lazy"
                    src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5f43460f09af66e941ef5_Frame.svg"
                    alt=""
                    className="image-24px"
                  />
                </div>
                <div className="vertical-left-top _150px">
                  <p className="_14px-text">Location</p>
                  <select
                    id="location"
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                    className="selection-field-hero w-select"
                    required
                  >
                    <option value="">Select Country</option>
                    <option value="Mbarara">Uganda</option>
                    <option value="Kampala">Kenya</option>
                    <option value="Entebbe">Rwanda</option>
                    <option value="Entebbe">Burundi</option>
                    <option value="Entebbe">Eritrea</option>
                    <option value="Entebbe">Somalia</option>
                    <option value="Entebbe">Nigeria</option>
                    <option value="Entebbe">South Africa</option>
                    <option value="Entebbe">Canada</option>
                    <option value="Entebbe">USA</option>
                    <option value="Entebbe">UK</option>
                    <option value="Entebbe">Tanzania</option>
                  </select>
                </div>
              </div>

              {/* Time Period */}
              <div className="horizontal-left-center-10px-gap">
                <div className="form-svg-wrapper">
                  <img
                    loading="lazy"
                    src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66bdd6264f4bd47788c7faac_Frame%204876.avif"
                    alt=""
                    className="image-24px"
                  />
                </div>
                <div className="vertical-left-top _150px">
                  <p className="_14px-text">Time Period</p>
                  <select
                    id="timePeriod"
                    name="timePeriod"
                    value={formData.timePeriod}
                    onChange={handleChange}
                    className="selection-field-hero w-select"
                    required
                  >
                    <option value="">Select Time Period</option>
                    <option value="01 day">01 day</option>
                    <option value="02 days">02 days</option>
                    <option value="03 days">03 days</option>
                    <option value="04 days">04 days</option>
                    <option value="05 days">05 days</option>
                    <option value="06 days">06 days</option>
                    <option value="07 days">07 days</option>
                    <option value="08 days">08 days</option>
                    <option value="09 days">09 days</option>
                    <option value="10 days">10 days</option>
                    <option value="11 days">11 days</option>
                    <option value="12 days">12 days</option>
                    <option value="13 days">13 days</option>
                    <option value="14 days">14 days</option>
                    <option value="15 days">15 days</option>
                    <option value="16 days">16 days</option>
                    <option value="18 days">18 days</option>
                    <option value="19 days">19 days</option>
                    <option value="20 days">20 days</option>
                    <option value="21 days">21 days</option>
                    <option value="22 days">22 days</option>
                    <option value="23 days">23 days</option>
                    <option value="24 days">24 days</option>
                    <option value="25 days">25 days</option>
                    <option value="26 days">26 days</option>
                    <option value="27 days">27 days</option>
                    <option value="28 days">28 days</option>
                    <option value="29 days">29 days</option>
                    <option value="30 days">30 days</option>
                  </select>
                </div>
              </div>

              {/* Tour Type */}
              <div className="horizontal-left-center-10px-gap">
                <div className="form-svg-wrapper">
                  <img
                    loading="lazy"
                    src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5f4344c732f65ed8ca225_Vector.svg"
                    alt=""
                    className="image-24px"
                  />
                </div>
                <div className="vertical-left-top _150px">
                  <p className="_14px-text">Tour Type</p>
                  <select
                    id="tourType"
                    name="tourType"
                    value={formData.tourType}
                    onChange={handleChange}
                    className="selection-field-hero w-select"
                    required
                  >
                    <option value="">Select Tour Type</option>
                    <option value="Family Tour">Family Tour</option>
                    <option value="Adventure Tour">Adventure Tour</option>
                    <option value="Cultural Tour">Cultural Tour</option>
                  </select>
                </div>
              </div>
              <div className="horizontal-left-center-10px-gap">
                {/* <div className="form-svg-wrapper">
                  <img
                    loading="lazy"
                    src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5f4344c732f65ed8ca225_Vector.svg"
                    alt=""
                    className="image-24px"
                  />
                </div> */}
                <div className="vertical-left-top _150px">
                  <p className="_14px-text">Email</p>
                  <input
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="selection-field-hero w-select color-input"
                    required
                  ></input>
                </div>
              </div>

              {/* Submit Button */}
              <input
                type="submit"
                disabled={isSubmitting}
                className="submit-button w-button"
                value={isSubmitting ? "Submitting..." : "Submit"}
              />
            </form>

            {/* Submission Status Messages */}
            {submissionStatus === "success" && (
              <div className="w-form-done" tabIndex="-1" role="region">
                <div>Thank you! Your submission has been received!</div>
              </div>
            )}
            {submissionStatus === "error" && (
              <div className="w-form-fail" tabIndex="-1" role="region">
                <div>Oops! Something went wrong while submitting the form.</div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Header;
